import { signOutEverywhere } from "../lib/supabase";

export function NotInstalled({ reason }: { reason?: string }) {
  return (
    <main className="center">
      <div className="card auth-card">
        <h1>{reason === "BK001" ? "Not open yet" : "Books isn't set up here yet"}</h1>
        <p className="muted">{reason === "BK001"
          ? "You're signed in, but Altekore Books isn't open for your account yet. It will be once it's rolled out to you."
          : "You're signed in, but Altekore Books hasn't been switched on for this region's database. It will be available once it's rolled out."}</p>
        <button className="link" onClick={() => void signOutEverywhere()}>Sign out</button>
      </div>
    </main>
  );
}
